import React, { useState } from 'react';
import { loginUser } from '../../services/api';
import './reconnectModal.css';

const ReconnectModal = ({ onReconnect, onLogout }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setErrorMessage('');
    setIsLoading(true);

    try {
      await loginUser(formData.username, formData.password);
      onReconnect();
    } catch (error) {
      console.error('Erreur lors de la reconnexion :', error);
      setErrorMessage('Identifiant ou mot de passe incorrect(s)');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="overlay reconnect-overlay">
      <div className="reconnect-modal">
        <form onSubmit={handleSubmit}>
          <h2>Session expirée</h2>
          <p className="reconnect-message">
            Votre session a expiré. Veuillez vous reconnecter pour continuer.
          </p>
          <div className="form-group">
            <label>Nom d'utilisateur</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Mot de passe</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />
          </div>
          <p className="errorMessage">{errorMessage}</p>
          <div className="reconnect-buttons">
            <button type="submit" disabled={isLoading}>
              {isLoading ? 'Connexion...' : 'Se reconnecter'}
            </button>
            <button type="button" className="secondary" onClick={onLogout}>
              Se déconnecter
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReconnectModal;
